import React from 'react';
import { Row, Col } from 'antd';
import DetailItem from "./../../../../CSIComponents/DetailItem";
import Collapse, {Panel} from '../../../../ui/Collapse';

interface propsTypes {
  dataList: void | any,
}
const UsageProgramsView = (props: propsTypes) => {
  const data = props.dataList?.environmentalimpact?.energyusage?.usageprogram || [];
  
  return (
    <>{data.length ?
      <Collapse defaultActiveKey={data.map((_: object, i : number) => i)} multiCollapseButton>
        {data.map((item: { desc: any; }, i: number) => {
          return (
            <Panel header={`Energy Usage Program ${i + 1}`} key={i} style={{ marginBottom: '20px' }}>
              <Row gutter={24}>
                <Col span={18}>
                  <DetailItem value={item.desc} label='Description' />
                </Col>
              </Row>
            </Panel>
          )
        })}
      </Collapse> : null
    }
    </>
  )
}


export default UsageProgramsView;